import {
  GET_EVALUATION_DIFF_FAIL,
  GET_EVALUATION_DIFF_SUCCESS,
  GET_OTHER_EVALUATION_FAIL,
  GET_OTHER_EVALUATION_SUCCESS,
  GET_SELF_EVALUATION_FAIL,
  GET_SELF_EVALUATION_SUCCESS
} from "../actions/evaluationConfirm";

const initialState = {
  selfEvaluationList: [],
  otherEvaluationList: [],
  evaluationDiffList: [],
  gradeRange: {},
};

const evaluationConfirm = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SELF_EVALUATION_SUCCESS:
      return {
        ...state,
        selfEvaluationList: payload.selfEvaluationList,
        gradeRange: payload.gradeRange
      };
    case GET_SELF_EVALUATION_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case GET_OTHER_EVALUATION_SUCCESS:
      return {
        ...state,
        otherEvaluationList: payload.otherEvaluationList,
        gradeRange: payload.gradeRange
      };
    case GET_OTHER_EVALUATION_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case GET_EVALUATION_DIFF_SUCCESS:
      return {
        ...state,
        evaluationDiffList: payload.evaluationDiffList,
        gradeRange: payload.gradeRange
      };
    case GET_EVALUATION_DIFF_FAIL:
      return {
        ...state,
        error: payload.error
      };
    default:
      return {
        ...state
      };
  }
};

export default evaluationConfirm;
